import { ref, set, get, remove } from 'firebase/database';
import { database } from '../firebaseConfig';
import { showsInPocketListings, toPocketRow } from '../shared/pocketListing';

// Residence Pocket Listing Database.
// crm/pocketListings/{sellerInterestId} is an abbreviated, team-readable mirror of a seller interest.
// It holds ONLY: community, floor plan, pool, view, min/max price, and the owning agent's name/phone/email.
// Never the seller's name, address, phone, email, notes or estimated price. crm/sellerInterests stays admin-only.
export const PL_PATH = 'crm/pocketListings';
export const PL_VIEWS = ['Landscape', 'Corner', 'Lake', 'Preserve'];

export const toPocketListing = (interest, agent) => toPocketRow(interest, 'seller', agent);
export { showsInPocketListings };

const agentInfo = async (uid) => {
  if (!uid) return null;
  try {
    const u = (await get(ref(database, `users/${uid}`))).val() || {};
    return { uid, name: u.displayName || u.name || u.email || '', email: u.email || '', phone: u.phone || u.cellPhone || u.mobile || '' };
  } catch (e) { return { uid, name: '', email: '', phone: '' }; }
};

// Write (or refresh) the mirror after a pipeline record is saved. kind is 'seller' (Seller/Landlord) or
// 'buyer' (Buyer/Tenant). The "Show in pocket listings" switch decides; converted records are removed.
export const syncPocketListing = async (interest, uid, kind = 'seller') => {
  if (!interest?.id) return;
  if (!showsInPocketListings(interest, kind)) { await removePocketListing(interest.id); return; }
  const agent = await agentInfo(interest.assignedAgentId || interest.createdBy || uid);
  await set(ref(database, `${PL_PATH}/${interest.id}`), toPocketRow(interest, kind, agent));
};

export const removePocketListing = async (interestId) => {
  if (!interestId) return;
  await remove(ref(database, `${PL_PATH}/${interestId}`));
};

// "$650K" / "$1.2M" style.
const num = (v) => { const n = Number(String(v || '').replace(/[^0-9.]/g, '')); return Number.isFinite(n) && n > 0 ? n : null; };
const short = (n) => (n >= 1e6 ? `$${(n / 1e6).toFixed(n % 1e6 ? 2 : 0).replace(/\.?0+$/, '')}M` : `$${Math.round(n / 1000)}K`);
export const priceNum = num;
export const priceRange = (min, max) => {
  const a = num(min); const b = num(max);
  if (a && b) return `${short(a)}\u2013${short(b)}`;
  if (a) return `${short(a)}+`;
  if (b) return `Up to ${short(b)}`;
  return '';
};
